/**
 * Pure JS highlighting - by surrounding with <mark> tags - of all `patterns`
 * in the `article` element. Manipulates the DOM so call it after the DOM is
 * ready.
 */
const highlightOnArticle = (patterns: string[]): void => {
  // \b is a word boundary
  const regexPatterns = patterns.map((p) => new RegExp(`\\b(${p})\\b`, 'g'));
  const article = document.body.querySelector('article');
  if (article) {
    article.querySelectorAll('*:not(mark)').forEach((element) => {
      if (
        element.childNodes.length === 1 &&
        !element.closest('.highcharts-container')
      ) {
        const node = element.childNodes[0];
        if (node.nodeType === document.TEXT_NODE) {
          element.innerHTML = regexPatterns.reduce<string>(
            (value, pattern) => value.replace(pattern, '<mark>$1</mark>'),
            node.textContent as string,
          );
        }
      }
    });
  }
};

export default highlightOnArticle;
